import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalAppDataStorageService } from "infra/storage";
import { Controller, useFormContext } from "react-hook-form";

export default function Compensation({ data }) {
    const { register, control } = useFormContext();

    const { availability, grossAnnualSalary, netMonthlySalary, noticePeriod } =
        data;

    const compensationPreferencesOptions =
        GlobalAppDataStorageService.getCompensationPreferences();

    const salaryCurrenciesOptions =
        GlobalAppDataStorageService.getSalaryCurrencies();

    return (
        <Box
            component="section"
            sx={{
                mb: 4,
                width: "100%",
                display: "grid",
                gap: 2,
                gridTemplateColumns: "repeat(4, 1fr)",
            }}
        >
            <Typography variant="h6" gutterBottom sx={{ gridColumn: "span 4" }}>
                Compensation Preferences
            </Typography>
            <Controller
                name="compensation.currencyId"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="currency_id"
                        autoComplete
                        limitTags={1}
                        fullWidth
                        options={salaryCurrenciesOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Currency"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="compensation.compensations"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="compensation.compensations"
                        multiple
                        autoComplete
                        fullWidth
                        options={compensationPreferencesOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Payment Method"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <TextField
                label="Net Monthly Salary"
                name="compensation.netMonthlySalary"
                required={netMonthlySalary?.metadata?.required || false}
                {...register("compensation.netMonthlySalary")}
                fullWidth
                variant="outlined"
                sx={{ gridColumn: { xs: "span 4", sm: "span 2" } }}
                type="number"
            />
            <TextField
                label="Gross Annual Salary"
                name="compensation.grossAnnualSalary"
                required={grossAnnualSalary?.metadata?.required || false}
                {...register("compensation.grossAnnualSalary")}
                fullWidth
                variant="outlined"
                sx={{ gridColumn: { xs: "span 4", sm: "span 2" } }}
                type="number"
            />
            <TextField
                label="Notice Period (weeks)"
                name="compensation.noticePeriod"
                required={noticePeriod?.metadata?.required || false}
                {...register("compensation.noticePeriod")}
                fullWidth
                variant="outlined"
                sx={{ gridColumn: { xs: "span 4", sm: "span 2" } }}
                type="number"
            />
            <TextField
                label="Availability"
                name="compensation.availability"
                required={availability?.metadata?.required || false}
                {...register("compensation.availability")}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                sx={{ gridColumn: { xs: "span 4", sm: "span 2" } }}
                type="month"
            />
        </Box>
    );
}
